(function () {
  var overlay = document.querySelector('.c-menu-overlay');
  if (!overlay) return;

  function openPanel(panel) {
    var current = overlay.querySelector('.c-menu-overlay__panel.is-active');
    if (current && current !== panel) {
      current.classList.remove('is-active');
      current.classList.add('is-prev');
      current.setAttribute('aria-hidden', 'true');
    }

    panel.classList.remove('is-prev');
    panel.classList.add('is-active');
    panel.setAttribute('aria-hidden', 'false');
    panel.scrollTop = 0;

    var trigger = document.querySelector('[data-menu-open="' + panel.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closePanel(panel) {
    panel.classList.remove('is-active');
    panel.setAttribute('aria-hidden', 'true');

    var trigger = document.querySelector('[data-menu-open="' + panel.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    var parentId = panel.getAttribute('data-parent-panel');
    if (parentId) {
      var parentPanel = document.getElementById(parentId);
      if (parentPanel) {
        parentPanel.classList.remove('is-prev');
        parentPanel.classList.add('is-active');
        parentPanel.setAttribute('aria-hidden', 'false');
      }
    }
  }

  function resetPanels() {
    overlay.querySelectorAll('.c-menu-overlay__panel').forEach(function (panel) {
      panel.classList.remove('is-active', 'is-prev');
      panel.setAttribute('aria-hidden', 'true');
    });
    overlay.querySelectorAll('[data-menu-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  overlay.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-menu-open]');
    if (openTrigger) {
      var panel = document.getElementById(openTrigger.getAttribute('data-menu-open'));
      if (panel) openPanel(panel);
      return;
    }

    var backTrigger = event.target.closest('[data-menu-back]');
    if (backTrigger) {
      var currentPanel = backTrigger.closest('.c-menu-overlay__panel');
      if (currentPanel) closePanel(currentPanel);
    }
  });

  resetPanels();

  // Reset drill-down state whenever the mobile menu itself closes,
  // so it always reopens at the root level next time.
  var observer = new MutationObserver(function () {
    if (!overlay.classList.contains('is-active')) {
      resetPanels();
    }
  });
  observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });
})();
